export class StencilState {
}
